
/* UNIVERSAL ARTIKEL – CUSTOM START: KI-LABEL V2 | 13.10.2026
 * Isolierte Overlay-Ebene direkt unter body. Keine Modifikation der Bildcontainer.
 * Testversion: sichtbare Inhaltsbilder; Logos, Icons und winzige Bilder ausgenommen.
 */
(() => {
  'use strict';
  const MIN_WIDTH = 90;
  const MIN_HEIGHT = 65;
  const SKIP = 'header__heading, .header__heading-link, .footer__content-top, .payment-icons, .list-payment, .icon, .shopify-payment-button, .ua-ki-label-layer';
  const labels = new Map();
  let layer;
  let scheduled = false;

  function initLayer() {
    if (layer || !document.body) return;
    layer = document.createElement('div');
    layer.className = 'ua-ki-label-layer';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);
  }

  function eligible(img) {
    if (!img.isConnected || img.closest(SKIP) || img.dataset.uaKiIgnore === 'true') return false;
    if (!img.complete || !img.naturalWidth) return false;
    const r = img.getBoundingClientRect();
    if (r.width < MIN_WIDTH || r.height < MIN_HEIGHT) return false;
    if (getComputedStyle(img).visibility === 'hidden' || getComputedStyle(img).display === 'none') return false;
    return true;
  }

  function update() {
    scheduled = false;
    initLayer();
    if (!layer) return;
    const seen = new Set();
    document.querySelectorAll('main img, .page-visual img').forEach(img => {
      if (!eligible(img)) return;
      const r = img.getBoundingClientRect();
      if (r.bottom <= 0 || r.top >= innerHeight || r.right <= 0 || r.left >= innerWidth) return;
      seen.add(img);
      let badge = labels.get(img);
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'ua-ki-label-v2';
        badge.textContent = 'KI-generiert';
        layer.appendChild(badge);
        labels.set(img, badge);
      }
      // Viewport coordinates; no modification of the image or its ancestors.
      badge.style.right = 'auto';
      badge.style.bottom = 'auto';
      badge.style.left = `${Math.max(0, r.right - badge.offsetWidth - 8)}px`;
      badge.style.top = `${Math.max(0, r.bottom - badge.offsetHeight - 8)}px`;
      badge.style.display = '';
    });
    for (const [img, badge] of labels) {
      if (!img.isConnected) {
        badge.remove();
        labels.delete(img);
      } else if (!seen.has(img)) {
        badge.style.display = 'none';
      }
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  function start() {
    initLayer();
    schedule();
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    document.addEventListener('load', schedule, true);
    document.addEventListener('mouseover', schedule, { passive: true });
    const observer = new MutationObserver(records => {
      if (records.every(r => r.target === layer || layer?.contains(r.target))) return;
      schedule();
    });
    observer.observe(document.querySelector('main') || document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'style', 'class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
/* UNIVERSAL ARTIKEL – CUSTOM ENDE: KI-LABEL V2 */
